/**
 *
 * @module metric
 *
 */

/**
 *
 * @class Metric
 * @property {Boolean} isPublic
 * @property {LogLevel} level
 * @property {String} name
 * @property {Object<String, JSONSerializable>} extraData
 *
 */
export default class Metric {

    /**
     *
     * @param {Boolean} [isPublic=false]
     * @param {LogLevel} [level=null]
     * @param {String} [name='']
     * @param {Object<String, JSONSerializable>} [extraData = {}]
     *
     */
    constructor(isPublic = false, level = null, name = '', extraData = {}) {

        /**
         *
         * @access private
         * @type {Boolean}
         *
         */
        this.isPublic = isPublic;

        /**
         *
         * @access private
         * @type {LogLevel}
         *
         */
        this.level = level;

        /**
         *
         * @access private
         * @type {String}
         *
         */
        this.name = name;

        /**
         *
         * @access private
         * @type {Object<String, JSONSerializable>}
         *
         */
        this.extraData = extraData;

    }

}



// WEBPACK FOOTER //
// ./src/logging/metric.js